import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: ItineraryTypes, Creators: ItineraryActions } = createActions(
  {
    clear: [],
    setItem: ['item'],
    cancelBooking: ['bookingId'],
    cancelBookingSuccess: ['bookingId'],
    cancelBookingFailure: ['bookingId'],
    showModal: ['bookingId', 'experienceName'],
    hideModal: [],
  },
  { prefix: 'ITINERARY_' }
);

export const INITIAL_STATE = Immutable({
  items: {},
  isCancelling: {},
  modal: {
    isVisible: false,
    bookingId: '',
    experienceName: '',
  },
});

const clear = () => INITIAL_STATE;

const setItem = (state, { item }) => state.setIn(['items', item.bookingId], item);

const cancelBooking = (state, { bookingId }) => state.setIn(['isCancelling', bookingId], true);

const clearIsCancelling = (state, { bookingId }) => state.setIn(['isCancelling', bookingId], false);

const showModal = (state, { bookingId, experienceName }) =>
  state.set('modal', { isVisible: true, bookingId, experienceName });

const hideModal = state => state.setIn(['modal', 'isVisible'], false);

export const reducer = createReducer(INITIAL_STATE, {
  [ItineraryTypes.CLEAR]: clear,
  [ItineraryTypes.SET_ITEM]: setItem,
  [ItineraryTypes.CANCEL_BOOKING]: cancelBooking,
  [ItineraryTypes.CANCEL_BOOKING_SUCCESS]: clearIsCancelling,
  [ItineraryTypes.CANCEL_BOOKING_FAILURE]: clearIsCancelling,
  [ItineraryTypes.SHOW_MODAL]: showModal,
  [ItineraryTypes.HIDE_MODAL]: hideModal,
});
